import React from 'react';
import { useParams } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import ApiProvider from '../../../apiProvider';
import { useState, useEffect } from 'react';
import ChangeReview from './changeReview';
import { useNavigate } from 'react-router-dom';

const AdminReview = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const numericId = parseInt(id, 10);
    const { accounts, instance } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [loading, setLoading] = useState(true); // Add loading state
    const [error, setError] = useState(null); // Add error state
    const [modalData, setModalData] = useState();
    const [reloadChange, setReloadChange] = useState(false);

        useEffect(() => {
            loadPendingChanges();
        }, [reloadChange]);

const loadPendingChanges = async () => {
    setLoading(true);
    setError(null);

    try {
        const results = await apiProvider.Get("Profile/GetPending"); 
         if (!results.error) {
            // Keep all pending changes
            const change = results.find((pc) => pc.id === numericId);
            setModalData(change);

        } else {
            setError("Failed to load pending changes. Please try again later.");
        }
    } catch (err) {
        setError("An error occurred while fetching pending changes.");
    } finally {
        setLoading(false);
    }
};

    const endChange = async () => {
        navigate(`/Profile/Admin`);
    }

  return (
        <div>
        {loading && <p>Loading...</p>}
        {error && <p>{error}</p>}
        {!loading && modalData && (
            <ChangeReview
            setShow={endChange}
            changeInfo={modalData}
            apiProvider={apiProvider}
            reloadChange = {reloadChange}
            setReloadChange = {setReloadChange}
            />
        )}
        {!loading && !modalData && !error && (
            <p>No change data found for ID {numericId}</p>
        )}
        </div>
    );
};

export default AdminReview;